export const HUD = () => {
	return (
		<mesh position={[0, 0.4, -1.0]}>
			{/* <Stats /> */}
			{/* <boxGeometry args={[0.2, 0.2, 0.2]} /> */}
		</mesh>
	);
};
